import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

// Phân phối thu thi hành án
const popupAllSummaryDetail = defineAsyncComponent(() => import('@/views/summary/allSummary/AllSummaryDetail.vue'));

const popupViewDetailOrg = defineAsyncComponent(() => import('@/views/summary/allSummary/ViewDetailOrg.vue'));

export function registerSummary(app) {
  app.component('AllSummaryDetail', popupAllSummaryDetail);
  app.component('ViewDetailOrg', popupViewDetailOrg);
}
export function registerAsset(app) {
  const registerConfig = {
    JusticeReceiptDetail: popupJusticeReceiptDetail,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Summary');
}
